const fixArmoredBlock = (text, header, footer) => {
  // Normalize CRLF line endings and trim extra whitespace
  text = text.replace(/\r\n/g, "\n").trim();

  // Ensure a newline after the header
  const headerRegex = new RegExp(`${header}\\s*`);
  text = text.replace(headerRegex, `${header}\n\n`);

  // If no Version/Comment header follows, add a blank line
  if (!text.startsWith(`${header}\nVersion:`) && !text.startsWith(`${header}\nComment:`)) {
    text = text.replace(`${header}\n`, `${header}\n\n`);
  }

  // If no Version/Comment header follows, add a blank line
  if (!text.startsWith(`${header}\nVersion:`) && !text.startsWith(`${header}\nComment:`)) {
    text = text.replace(`${header}\n`, `${header}\n\n`);
  }

  // Ensure a single newline before the footer
  const footerRegex = new RegExp(`\\s*${footer}`);
  text = text.replace(footerRegex, `\n${footer}`);

  // End with a newline for consistent formatting
  if (!text.endsWith("\n")) {
    text += "\n";
  }

  return text;
};

export const fixArmoredMessage = (msg) =>
  fixArmoredBlock(
    msg,
    "-----BEGIN PGP MESSAGE-----",
    "-----END PGP MESSAGE-----",
  );

export const fixArmoredPublicKey = (key) =>
  fixArmoredBlock(
    key,
    "-----BEGIN PGP PUBLIC KEY BLOCK-----",
    "-----END PGP PUBLIC KEY BLOCK-----",
  );

export const fixArmoredPrivateKey = (key) =>
  fixArmoredBlock(
    key,
    "-----BEGIN PGP PRIVATE KEY BLOCK-----",
    "-----END PGP PRIVATE KEY BLOCK-----",
  );
